import { Action } from '@components/MultipleActionsInterfaces';
import { Copy, CopyPlus, Trash2 } from 'lucide-react';
import LangEnum from '../../../../lang/LangEnum';

export type OrderProductsMassActionType =
  | 'remove_order_products_from_order'
  | 'copy_order_products_to_new_order'
  | 'copy_order_products_to_existing_order';

export const buildOrderProductsMassActions = (): Action<OrderProductsMassActionType>[] => [
  {
    label: LangEnum.CATALOGS_PRODUCTS_REMOVE_FROM_ORDER,
    icon: Trash2,
    type: 'remove_order_products_from_order',
    isMassAction: true,
  },
  {
    label: LangEnum.COPY_TO_NEW_ORDER,
    icon: CopyPlus,
    type: 'copy_order_products_to_new_order',
    isMassAction: true,
  },
  {
    label: LangEnum.COPY_TO_EXISTING_ORDER,
    icon: Copy,
    type: 'copy_order_products_to_existing_order',
    isMassAction: true,
  },
];
